<template>
    <li>
        <message-component v-show="showMessage" :title="title" :status="messageStatus" :message="messageText" :on-footballer-lives-page="onFootballerLivesPage"></message-component>
        <select v-model="selected" v-on:change="update" class="language-select">
            <option
                v-for="language in languages"
                :value="language.code">{{ title }}: {{ getLocalisedLanguageName(language.name) }}
            </option>
        </select>
    </li>
</template>
<script>
    import axios from 'axios'
    import { find, lowerCase } from 'lodash'

    export default {
        props: ['languages', 'title', 'language', 'messages', 'onFootballerLivesPage', 'languagesLocalised'],
        data() {
            return {
                selected: null,
                showMessage: false,
                messageStatus: 'generic',
                messageText: this.messages.message_success
            };
        },
        mounted() {
            this.selected = this.language
        },
        methods: {
            getLocalisedLanguageName(langName) {
                const lang = find(this.languagesLocalised, (x, index) => index === lowerCase(langName))
                if (lang) {
                    return lang
                }
                return langName
            },
            update() {
                axios.post('/api/settings/update-language', {
                    language: this.selected
                }).then((response) => {
                    this.messageText = response.data.message;
                    this.messageStatus = 'generic';
                    this.showMessage = true;
                    setTimeout(() => {
                        this.showMessage = false;
                    }, 2000);

                    // will have removed 'locale' param in url if set
                    location.replace(response.data.redirect);
                }).catch((error) => {
                    this.messageText = error.response.data.message;
                    this.messageStatus = 'error';
                    this.showMessage = true;
                    setTimeout(() => {
                        this.showMessage = false;
                    }, 2000);
                });
            }
        }
    }
</script>
